export default __webpack_public_path__ + "static/puneeta-f5f91929c89e64c0d29f0db5943ef004.jpg";